import { defineStore } from 'pinia'

import type { LessonEditStore } from './interfaces'

import { actions } from './actions'
import { getters } from './getters'
import { createLessonEditState } from './state'

export const useLessonEditStore = defineStore('lesson-edit', {
  state: (): LessonEditStore => createLessonEditState(),
  actions,
  getters,
})
